import { apiClient } from "@/services/api";

const state = () => ({
    camerasProducao: null,
    camerasEmExibicao: null,
    flg_favorita: false,
    filtroCameras: localStorage.getItem('@socialcam/filtro_texto_cameras') || null,
    filtroCamerasModeradas: localStorage.getItem('@socialcam/filtro_texto_cameras_moderadas') || null,
    selectedPraca: null,
    tarjaParams: null,
    camerasPraca: null
})

const getters = {
    getterCameras: state => {
        return state.camerasProducao
    },
    getterCamerasPraca: state => {
        return state.camerasPraca
    },
    getterCamerasEmExibicao: state => {
        return state.camerasEmExibicao
    },
    getterFiltroCameras: state => {
        return state.filtroCameras
    },
    getterSelectedPraca: state => {
        return state.selectedPraca
    },
    getterFiltroCamerasModeradas: state => {
        return state.filtroCamerasModeradas
    },
    getterTarjaParams: state => {
        return state.tarjaParams
    }

}

const actions = {
    async getCameras({ commit }, payload) {
        const { filtro_texto, flg_favorita, page, size, cod_praca, cod_producao} = payload;

        if(!cod_praca) return;

        const params = {
            filtro_texto: filtro_texto || '',
            page        : page || '1',
            size        : size || '10',
            flg_favorita: flg_favorita,
            cod_praca  : cod_praca,
            cod_producao: cod_producao
        }

        Object.keys(params).forEach(k => {
            if (params[k] === null || (k === 'id_portal' && params[k] === '')) {
                delete params[k]
            }
        })

        const queryString = new URLSearchParams(params).toString()
        const url = `cameras/?${queryString}`

        try {
            const { data } = await apiClient.get(url)
            commit('setCamerasProducao', data.cameras)
        } catch (error) {
            console.error(error)
        }

    },
    async getCamerasModeradas({ commit }, payload) {
        const { filtro_texto, page, size, cod_producao} = payload;
        if(!cod_producao) {
            return;
        }

        const params = {
            filtro_texto: filtro_texto || '',
            page        : page || '1',
            size        : size || '10',
        }

        Object.keys(params).forEach(k => {
            if (params[k] === null || (k === 'id_portal' && params[k] === '')) {
                delete params[k]
            }
        })

        const queryString = new URLSearchParams(params).toString()
        const url = `cameras/getModeradas/${cod_producao}/?${queryString}`

        try {
            const { data } = await apiClient.get(url)
            commit('setCamerasEmExibicao', data.cameras)
        } catch (error) {
            console.error(error)
        }
    },
    setSelectedPraca({ commit }, value) {
        try {
            commit('setSelectedPraca', value)
        } catch (error) {
            console.error(error)
        }
    },
    setFiltroCameras({ commit }, value) {
        try {
            commit('setFiltroCameras', value)
        } catch (error) {   
            console.error(error)
        }
    },

    setFiltroCamerasModeradas({ commit }, value) {
        try {
            commit('setFiltroCamerasModeradas', value)
        } catch (error) {
            console.error(error)
        }
    },
    setFlgFavorita({ commit }, value) {
        try {
            commit('setFlgFavorita', value)
        } catch (error) {
            console.error(error)
        }
    },
    assignTarjaParams({ commit }, payload) {
        commit('setTarjaParams', payload)
    },
    async getCamerasByPraca({ commit }, payload) {
        const { filtro_texto, page, size, cod_praca} = payload;

        const params = {
            filtro_texto: filtro_texto || '',
            page        : page || '1',
            size        : size || '10',
        }

        Object.keys(params).forEach(k => {
            if (params[k] === null || (k === 'id_portal' && params[k] === '')) {
                delete params[k]
            }
        })
        const queryString = new URLSearchParams(params).toString()
        const url = `cameras/getByPraca/${cod_praca}/?${queryString}`

        try {
            const { data } = await apiClient.get(url)
            commit('setCamerasPraca', data.cameras)
        } catch (error) {
            console.error(error)
        }

    }

}

const mutations = {
    setCamerasProducao(state, value) {
        state.camerasProducao = value
    },
    setCamerasEmExibicao(state, value) {
        state.camerasEmExibicao = value
    },
    setFlgFavorita(state, value) {
        state.flg_favorita = value
    },
    setFiltroCameras(state, value) {
        state.filtroCameras = value
    },
    setSelectedPraca(state, value) {
        state.selectedPraca = value
    },
    setFiltroCamerasModeradas(state, value) {
        state.filtroCamerasModeradas = value
    },
    setTarjaParams(state, payload) {
        state.tarjaParams = payload
    },
    setCamerasPraca(state, payload) {
        state.camerasPraca = payload;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}